module.exports = __webpack_public_path__ + "img/21.e8e3f383.jpg";